const ROUTES = {};

export default ROUTES;